(function() {
  'use strict';

  var hatProductIds = null;

  function getHatProductIds() {
    if (hatProductIds !== null) {
      return hatProductIds;
    }
    var el = document.getElementById('hat-product-ids');
    if (!el) {
      hatProductIds = [];
      return hatProductIds;
    }
    try {
      hatProductIds = JSON.parse(el.textContent || '[]');
    } catch (e) {
      hatProductIds = [];
    }
    return hatProductIds;
  }

  function isHatItem(item) {
    var ids = getHatProductIds();
    if (ids.indexOf(item.product_id) !== -1) {
      return true;
    }
    return false;
  }

  function formatMoney(cents, moneyFormat) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function replaceAmount(template, amount) {
    return template.split('{amount}').join(amount);
  }

  function computeGoal(cart, goalEl) {
    var threshold = parseInt(goalEl.getAttribute('data-threshold'), 10) || 14900;
    var moneyFormat = goalEl.getAttribute('data-money-format') || '${{amount}}';
    var messageAway = goalEl.getAttribute('data-message-away') || "You're {amount} away from free shipping!";
    var messageUnlocked = goalEl.getAttribute('data-message-unlocked') || "You've unlocked free shipping!";
    var messageHatsOnly = goalEl.getAttribute('data-message-hats-only') || 'Hats are excluded from free shipping offers.';
    var messageHatsNote = goalEl.getAttribute('data-message-hats-note') || 'Hats excluded from free shipping.';

    var qualifyingSubtotal = 0;
    var hasHat = false;
    var hasNonHat = false;
    var items = (cart && cart.items) ? cart.items : [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isHatItem(item)) {
        hasHat = true;
      } else {
        hasNonHat = true;
        qualifyingSubtotal += item.final_line_price || item.line_price || 0;
      }
    }

    var remaining = threshold - qualifyingSubtotal;
    if (remaining < 0) {
      remaining = 0;
    }

    var progress = 0;
    if (threshold > 0) {
      progress = Math.round((qualifyingSubtotal / threshold) * 100);
    }
    if (progress > 100) {
      progress = 100;
    }

    var state = 'away';
    if (items.length > 0 && hasHat && !hasNonHat) {
      state = 'hats_only';
    } else if (qualifyingSubtotal >= threshold) {
      state = 'unlocked';
    }

    var message = replaceAmount(messageAway, formatMoney(remaining, moneyFormat));
    if (state === 'unlocked') {
      message = messageUnlocked;
    } else if (state === 'hats_only') {
      message = messageHatsOnly;
    }

    return {
      state: state,
      message: message,
      progress: progress,
      ariaNow: Math.round(qualifyingSubtotal / 100),
      thresholdDollars: Math.round(threshold / 100),
      showHatsNote: state !== 'hats_only' && hasHat && hasNonHat,
      hatsNote: messageHatsNote
    };
  }

  function updateGoalElement(goalEl, result) {
    var messageEl = goalEl.querySelector('.free-shipping-goal__message');
    var trackEl = goalEl.querySelector('.free-shipping-goal__track');
    var fillEl = goalEl.querySelector('.free-shipping-goal__fill');
    var noteEl = goalEl.querySelector('.free-shipping-goal__note');

    goalEl.setAttribute('data-state', result.state);
    goalEl.className = 'free-shipping-goal free-shipping-goal--' + result.state;

    if (messageEl) {
      messageEl.textContent = result.message;
    }

    if (result.state === 'hats_only') {
      if (trackEl) {
        trackEl.setAttribute('aria-hidden', 'true');
        trackEl.classList.add('free-shipping-goal__track--hidden');
        trackEl.removeAttribute('role');
      }
      if (fillEl) {
        fillEl.style.width = '0%';
      }
    } else if (trackEl && fillEl) {
      trackEl.classList.remove('free-shipping-goal__track--hidden');
      trackEl.removeAttribute('aria-hidden');
      trackEl.setAttribute('role', 'progressbar');
      trackEl.setAttribute('aria-valuemin', '0');
      trackEl.setAttribute('aria-valuemax', String(result.thresholdDollars));
      trackEl.setAttribute('aria-valuenow', String(result.ariaNow));
      trackEl.setAttribute('aria-label', 'Free shipping progress');
      fillEl.style.width = result.progress + '%';
    }

    if (result.showHatsNote) {
      if (!noteEl) {
        noteEl = document.createElement('p');
        noteEl.className = 'free-shipping-goal__note';
        goalEl.appendChild(noteEl);
      }
      noteEl.textContent = result.hatsNote;
      noteEl.style.display = '';
    } else if (noteEl) {
      noteEl.style.display = 'none';
    }
  }

  function updateFreeShippingGoal(cart) {
    var goals = document.querySelectorAll('.free-shipping-goal');
    if (!goals.length) {
      return;
    }

    function apply(cartData) {
      for (var i = 0; i < goals.length; i++) {
        updateGoalElement(goals[i], computeGoal(cartData, goals[i]));
      }
    }

    if (cart) {
      apply(cart);
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) {
        return response.json();
      })
      .then(apply)
      .catch(function() {});
  }

  window.updateFreeShippingGoal = updateFreeShippingGoal;

  function initPinnedHeader() {
    var section = document.getElementById('shopify-section-header');
    if (!section) {
      return;
    }

    if (!section.querySelector('.header-fixed--true, .mobile_nav-fixed--true')) {
      return;
    }

    var resizeTimer = null;
    var scrollTicking = false;

    function measureHeaderHeight() {
      var height = section.offsetHeight;
      document.documentElement.style.setProperty('--penners-header-height', height + 'px');
    }

    function onScroll() {
      if (scrollTicking) {
        return;
      }
      scrollTicking = true;
      window.requestAnimationFrame(function() {
        section.classList.toggle('is-scrolled', window.pageYOffset > 8);
        scrollTicking = false;
      });
    }

    section.classList.add('is-header-pinned');
    document.body.classList.add('is-header-pinned');
    measureHeaderHeight();
    onScroll();

    var headerImages = section.querySelectorAll('img');
    for (var j = 0; j < headerImages.length; j++) {
      if (!headerImages[j].complete) {
        headerImages[j].addEventListener('load', measureHeaderHeight);
      }
    }

    window.addEventListener('load', measureHeaderHeight);

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureHeaderHeight, 100);
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    var promoCloseButtons = section.querySelectorAll('.promo_banner-close');
    for (var i = 0; i < promoCloseButtons.length; i++) {
      promoCloseButtons[i].addEventListener('click', function() {
        setTimeout(measureHeaderHeight, 50);
        setTimeout(measureHeaderHeight, 350);
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        measureHeaderHeight();
      });
      observer.observe(section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  function boot() {
    updateFreeShippingGoal();
    initPinnedHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('ajaxComplete', function(event, xhr, settings) {
      if (settings && settings.url && /\/cart\/(add|change|update)\.js/.test(settings.url)) {
        updateFreeShippingGoal();
      }
    });

    jQuery('body').on('change', '.cart_content input.quantity', function() {
      setTimeout(updateFreeShippingGoal, 300);
    });

    jQuery('body').on('change', '#cart_form input.quantity', function() {
      setTimeout(updateFreeShippingGoal, 300);
    });
  }
})();
